export default 'v1.1.0';
